// import { useState, useEffect } from "react";

// // 👇 Apni exported image yahan se import karo (path apne project ke hisaab se change karo)
// import bgImage from "../../Assests/Images/BannerFooter.png";
// import PlayStoreIcon from "../../Assests/Images/PlayStoreButton.png";
// import ImageFooter from '../../Assests/Images/PhoneFooter.png'
// export default function CTASection() {
//   const [visible, setVisible] = useState(false);
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth <= 768 : false
//   );

//   useEffect(() => {
//     const t = setTimeout(() => setVisible(true), 100);
//     return () => clearTimeout(t);
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Sora:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap');
//         * { box-sizing: border-box; margin: 0; padding: 0; }

//         .store-btn {
//           display: inline-flex;
//           align-items: center;
//           gap: 10px;
//           padding: 12px 22px;
//           border-radius: 12px;
//           border: 1.5px solid rgba(255,255,255,0.3);
//           background: white;
//           color: white;
//           cursor: pointer;
//           text-decoration: none;
//           transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
//           backdrop-filter: blur(6px);
//           -webkit-backdrop-filter: blur(6px);
//         }
//         .store-btn:hover {
//           background: rgba(255,255,255,0.20);
//           border-color: rgba(255,255,255,0.5);
//           transform: translateY(-2px);
//         }
//         .store-btn-label {
//           display: flex;
//           flex-direction: column;
//           align-items: flex-start;
//           line-height: 1.2;
//         }
//         .store-btn-sub {
//           font-size: 10px;
//           color: rgba(255,255,255,0.6);
//           font-family: 'Inter var';
//           font-weight: 400;
//           color: black;
          
//         }
//         .store-btn-name {
//           font-size: 15px;
//           font-family: 'Inter var';
//           font-weight: 600;
//           color: black;
          
//         }
//       `}</style>

//       <div style={{
//         padding: isMobile ? "38px 14px" : "80px 24px",
//         background: "#FAFAFA",
//         fontFamily: "'Inter var'",
//       }}>
//         <div style={{
//           maxWidth: "1200px",
//           margin: "0 auto",
//           borderRadius: "24px",
//           overflow: "hidden",
//           position: "relative",
//           minHeight: isMobile ? "380px" : "420px",
//           display: "flex",
//           alignItems: "center",
//           // opacity: visible ? 1 : 0,
//           // transform: visible ? "translateY(0)" : "translateY(24px)",
//           // transition: "opacity 0.7s ease, transform 0.7s ease",
//           paddingTop: isMobile ? "0" : "40px",
//         }}>

//           {/* Background Image — teri exported Figma image */}
//           <img
//             src={bgImage}
//             alt="App mockup"
//             style={{
//               position: "absolute",
//               inset: 0,
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               objectPosition: isMobile ? "center" : "right center",
//             }}
//           />

//           {/* Gradient overlay — left pe dark, right pe transparent */}
//           <div style={{
//             position: "absolute",
//             inset: 0,
//             // background: isMobile
//             //   ? "linear-gradient(to bottom, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.62) 50%, rgba(0,0,0,0.45) 100%)"
//             //   : "linear-gradient(to right, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.80) 40%, rgba(0,0,0,0.15) 70%, transparent 100%)",
//             zIndex: 1,
//           }} />

//           {/* Text + Buttons */}
//           <div style={{
//             position: "relative",
//             zIndex: 2,
//             padding: isMobile ? "30px 18px" : "52px 56px",
//             maxWidth: isMobile ? "100%" : "520px",
//             width: "100%",
//             textAlign: isMobile ? "center" : "left",
//           }}>
//             <h2 style={{
//               fontFamily: "'Inter var'",
//               fontWeight: "500",
//               fontSize: isMobile ? "31px" : "clamp(26px, 3.5vw, 42px)",
//               color: "white",
//               letterSpacing: "-1px",
//               lineHeight: "1.15",
//               marginBottom: isMobile ? "20px" : "32px",
//             }}>
//               Ready To Skip<br />The Waiting Room?
//             </h2>

//             <p style={{
//               color: "rgba(255,255,255,0.86)",
//               fontSize: "14px",
//               lineHeight: "1.6",
//               marginBottom: isMobile ? "18px" : "28px",
//             }}>
//               Book verified car service experts instantly with Fuelingo.
//             </p>

//             <div style={{ display: "flex", gap: "14px", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row" }}>
//                 <img href="https://play.google.com/store" target="_blank" rel="noreferrer" src={PlayStoreIcon} alt="Play Store" style={{ width: "200px", height: "100px", objectFit: "contain" }} />

//             </div>
//           </div>

//         </div>
//       </div>
//     </>
//   );
// }
import React, { useState, useEffect } from "react";

// Paths ko apne project ke hisaab se check kar lein
// import AppleStoreIcon from "../../Assests/Images/AppStoreButton.png"; // Agar image hai
import PlayStoreIcon from "../../Assests/Images/PlayStoreButton.png";
import PhoneMockup from "../../Assests/Images/PhoneFooter.png"; // Woh jo 2 phones dikh rahe hain

export default function CTASection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section style={{ 
      padding: isMobile ? "40px 20px" : "80px 40px", 
      backgroundColor: "#ffffff" // Background page ka white
    }}>
      <div style={{
        maxWidth: "1200px",
        margin: "0 auto",
        backgroundColor: "#000000", // Banner black color
        borderRadius: "24px",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        minHeight: isMobile ? "auto" : "400px",
        // Grid pattern background effect
        backgroundImage: `radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)`,
        backgroundSize: "30px 30px",
      }}>
        
        {/* Left Side: Content */}
        <div style={{
          flex: 1,
          padding: isMobile ? "40px 24px 20px 24px" : "60px 80px",
          zIndex: 2,
          textAlign: isMobile ? "center" : "left"
        }}>
          <h2 style={{
            color: "#ffffff",
            fontSize: isMobile ? "32px" : "48px",
            fontWeight: "600",
            lineHeight: "1.2",
            margin: "0 0 40px 0",
            fontFamily: "'Inter', sans-serif",
            letterSpacing: "-0.02em"
          }}>
            Ready To Skip <br />
            The Waiting Room?
          </h2>

          <div style={{ 
            display: "flex", 
            gap: "16px", 
            justifyContent: isMobile ? "center" : "flex-start",
            flexWrap: "wrap"
          }}>
            {/* App Store Button */}
            {/* <a href="#" style={{ transition: "0.3s" }}>
              <img 
                src={AppleStoreIcon} 
                alt="App Store" 
                style={{ height: "50px", width: "auto", cursor: "pointer" }} 
              />
            </a> */}
            
            {/* Play Store Button */}
            <a href="#" style={{ transition: "0.3s" }}>
              <img 
                src={PlayStoreIcon} 
                alt="Play Store" 
                style={{ height: "50px", width: "auto", cursor: "pointer" }} 
              />
            </a>
          </div>
        </div>

        {/* Right Side: Phone Mockup */}
        <div style={{
          flex: 1,
          position: "relative",
          width: "100%",
          height: isMobile ? "300px" : "400px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden"
        }}>
          <img 
            src={PhoneMockup} 
            alt="App Mockup" 
            style={{
              width: isMobile ? "90%" : "110%",
              height: "auto",
              objectFit: "contain",
              // Image ko thoda tilted dikhane ke liye agar mockup seedha hai
              transform: isMobile ? "translateY(20px)" : "rotate(-5deg) translate(20px, 40px)",
              zIndex: 1
            }}
          />
          
          {/* Subtle Glow Effect behind phones */}
          <div style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            background: "rgba(255, 255, 255, 0.05)",
            filter: "blur(80px)",
            borderRadius: "50%",
            zIndex: 0
          }}></div>
        </div>

      </div>

      {/* Global CSS for fonts and hover effects */}
      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@500;600;700&display=swap');
        
        a:hover {
          opacity: 0.8;
          transform: translateY(-2px);
        }
      `}} />
    </section>
  );
}